import { ChangeDetectionStrategy, Component, effect, EventEmitter, inject, Input, Output, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { startWith } from 'rxjs';
import { DiscreetSelectComponent, DiscreetSelectOption } from '../ui/discreet-select/discreet-select.component';

@Component({
  selector: 'app-role-selector',
  standalone: true,
  imports: [TranslateModule, DiscreetSelectComponent],
  template: ` <ui-discreet-select [value]="value" [options]="translatedRoles()" (valueChange)="onRoleChange($event)" /> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoleSelectorComponent {
  @Input() value: string;
  @Output() valueChange = new EventEmitter<string>();

  private translate = inject(TranslateService);
  private langChange = toSignal(this.translate.onLangChange.pipe(startWith(null)));

  private baseRoles: DiscreetSelectOption[] = [
    { viewValue: 'GroupOverview.Role.Admin', value: 'Admin' },
    { viewValue: 'GroupOverview.Role.Writer', value: 'Writer' },
    { viewValue: 'GroupOverview.Role.Reader', value: 'Reader' },
  ];

  public translatedRoles = signal<DiscreetSelectOption[]>([]);

  constructor() {
    effect(() => {
      this.langChange(); // Depend on language changes
      const translated = this.baseRoles.map((role) => ({
        ...role,
        viewValue: this.translate.instant(role.viewValue),
      }));
      this.translatedRoles.set(translated);
    });
  }

  onRoleChange(newValue: string): void {
    this.valueChange.emit(newValue);
  }
}
